let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8dyWu")).then(() => parcelRequire('e3FDi'));